<template>
  <div class="inner-card" :style="{ background: backgroundColor }">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <ValidationObserver v-slot="{ handleSubmit }">
      <div class="row">
        <div class="col-md-6">
          <div class="field">
            <ValidationProvider
              class="w-100"
              v-slot="{ errors }"
              rules="required"
            >
              <div class="field-title">
                <span class="mark">*</span>
                <span :style="{ color: fontColor }">
                  是否有工作經驗？
                  <span class="en-text">Have any work experience?</span>
                </span>
              </div>
              <div class="field-radio">
                <label>
                  <input type="radio" :value="true" v-model="hasExperience" />
                  <span>是 (Yes)</span>
                </label>
                <label>
                  <input type="radio" :value="false" v-model="hasExperience" />
                  <span>否 (NO)</span>
                </label>
              </div>
              <span v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
              </span>
            </ValidationProvider>
          </div>
        </div>

        <div class="col-md-6"></div>

        <template v-for="(item, index) in workExperience">
          <div class="col-md-6" :key="'Company' + index">
            <div class="field">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <div class="field-title">
                  <span class="mark">*</span>
                  <span :style="{ color: fontColor }">
                    公司名稱
                    <span class="en-text">Company name</span>
                  </span>
                </div>
                <div class="field-value">
                  <input
                    type="text"
                    maxlength="200"
                    autocomplete="off"
                    readonly
                    @focus="$common.removeReadonly($event)"
                    v-model="item.Company"
                  />
                </div>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6" :key="'Seniority' + index">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  年資
                  <span class="en-text">Seniority</span>
                </span>
              </div>
              <div class="field-value">
                <input type="text" disabled v-model="item.Seniority" />
              </div>
            </div>
          </div>

          <div class="col-md-6" :key="'IndustryCategory' + index">
            <div class="field">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <div class="field-title">
                  <span class="mark">*</span>
                  <span :style="{ color: fontColor }">
                    產業類別
                    <span class="en-text">Industry category</span>
                  </span>
                </div>
                <div class="field-value">
                  <el-select
                    class="w-100"
                    placeholder="請選擇"
                    v-model="item.IndustryCategory"
                  >
                    <el-option
                      label="電子產業 (Electronics Industry)"
                      :value="0"
                    />
                    <el-option
                      label="封測產業 (Semi-conductors Industry)"
                      :value="1"
                    />
                    <el-option
                      label="傳統產業 (Traditional Industries)"
                      :value="2"
                    />
                    <el-option label="其他產業 (Other Industries)" :value="3" />
                  </el-select>
                </div>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6" :key="'Position' + index">
            <div class="field">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <div class="field-title">
                  <span class="mark">*</span>
                  <span :style="{ color: fontColor }">
                    <span :style="{ color: fontColor }">
                      職務
                      <span class="en-text">Duties</span>
                    </span>
                  </span>
                </div>
                <div class="field-value">
                  <input
                    type="text"
                    maxlength="50"
                    autocomplete="off"
                    readonly
                    @focus="$common.removeReadonly($event)"
                    v-model="item.Position"
                  />
                </div>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-12" :key="'WorkContent' + index">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  主要工作內容
                  <span class="en-text">Main work content</span>
                </span>
              </div>
              <div class="field-value">
                <el-input
                  class="w-100"
                  type="textarea"
                  :rows="4"
                  maxlength="10000"
                  show-word-limit
                  v-model="item.WorkContent"
                />
              </div>
            </div>
          </div>

          <div class="col-md-6" :key="'SpanOfManagement' + index">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  管理幅度(人)
                  <span class="en-text">Management range (of people)</span>
                </span>
              </div>
              <div class="field-value">
                <input
                  type="number"
                  min="0"
                  max="99999"
                  onkeyup="value=value.replace(/\D/g,'')"
                  v-model="item.SpanOfManagement"
                />
              </div>
            </div>
          </div>

          <div class="col-md-6" :key="'onTheJob' + index">
            <div class="field">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <div class="field-title">
                  <span class="mark">*</span>
                  <span :style="{ color: fontColor }">
                    是否仍在職？
                    <span class="en-text">Are still working?</span>
                  </span>
                </div>
                <div class="field-radio">
                  <label>
                    <input type="radio" :value="true" v-model="item.OnTheJob" />
                    <span>是 (Yes)</span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      :value="false"
                      v-model="item.OnTheJob"
                    />
                    <span>否 (Yes)</span>
                  </label>
                </div>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-12" :key="'LeaveReason' + index">
            <div class="field">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <div class="field-title">
                  <span class="mark">*</span>
                  <span :style="{ color: fontColor }">
                    (欲)離職原因
                    <span class="en-text">Reason for resignation</span>
                  </span>
                </div>
                <div class="field-value">
                  <el-input
                    class="w-100"
                    type="textarea"
                    :rows="4"
                    maxlength="10000"
                    show-word-limit
                    v-model="item.LeaveReason"
                  />
                </div>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6" :key="'ExperienceFrom' + index">
            <div class="field">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <div class="field-title">
                  <span class="mark">*</span>
                  <span :style="{ color: fontColor }">
                    工作起始年月
                    <span class="en-text">Service period (Start)</span>
                  </span>
                </div>
                <div class="field-value">
                  <el-date-picker
                    class="w-100"
                    type="month"
                    value-format="yyyy-MM"
                    :picker-options="{
                      disabledDate: $common.disabledDateAfterToday,
                    }"
                    placeholder="YYYY-MM"
                    v-model="item.ExperienceFrom"
                  />
                </div>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6" :key="'ExperienceTo' + index">
            <div class="field">
              <ValidationProvider
                :rules="{
                  required: !item.OnTheJob ? true : false,
                  notBeforeStartDate: !item.OnTheJob
                    ? item.ExperienceFrom
                    : false,
                }"
                v-slot="{ errors }"
              >
                <div class="field-title">
                  <span v-if="!item.OnTheJob" class="mark">*</span>
                  <span :style="{ color: fontColor }">
                    工作終止年月
                    <span class="en-text">Service period (End)</span>
                  </span>
                </div>
                <div class="field-value">
                  <el-date-picker
                    class="w-100"
                    type="month"
                    value-format="yyyy-MM"
                    :disabled="item.OnTheJob"
                    placeholder="YYYY-MM"
                    v-model="item.ExperienceTo"
                  />
                </div>
                <span v-if="errors[0]" class="text-danger">
                  {{ errors[0] }}
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6" :key="'BasicSalary' + index">
            <div class="field">
              <ValidationProvider
                class="w-100"
                name="底薪"
                :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                v-slot="{ errors }"
              >
                <div class="field-title">
                  <span :style="{ color: fontColor }">
                    底薪
                    <span class="en-text">Basic salary</span>
                  </span>
                </div>
                <div class="field-value">
                  <input type="text" v-model.trim="item.BasicSalary" />
                </div>
                <span v-if="errors" class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6" :key="'FixedAllowance' + index">
            <div class="field">
              <ValidationProvider
                class="w-100"
                name="固定津貼"
                :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                v-slot="{ errors }"
              >
                <div class="field-title">
                  <span :style="{ color: fontColor }">
                    固定津貼
                    <span class="en-text">Fixed allowance</span>
                  </span>
                </div>
                <div class="field-value">
                  <input type="text" v-model.trim="item.FixedAllowance" />
                </div>
                <span v-if="errors" class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6" :key="'VaryingBonus' + index">
            <div class="field">
              <ValidationProvider
                class="w-100"
                name="變動獎金"
                :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                v-slot="{ errors }"
              >
                <div class="field-title">
                  <span :style="{ color: fontColor }">
                    變動獎金
                    <span class="en-text">Varying bonus</span>
                  </span>
                </div>
                <div class="field-value">
                  <input type="text" v-model.trim="item.VaryingBonus" />
                </div>
                <span v-if="errors" class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-6" :key="'YearlySalary' + index">
            <div class="field">
              <ValidationProvider
                class="w-100"
                name="年薪"
                :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                v-slot="{ errors }"
              >
                <div class="field-title">
                  <span :style="{ color: fontColor }">
                    年薪
                    <span class="en-text">Yearly income</span>
                  </span>
                </div>
                <div class="field-value">
                  <input type="text" v-model.trim="item.YearlySalary" />
                </div>
                <span v-if="errors" class="text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="col-md-3" :key="'WorkCounty' + index">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  工作縣市
                  <span class="en-text">Work location (City)</span>
                </span>
              </div>
              <div class="field-value">
                <el-select
                  class="w-100"
                  filterable
                  placeholder="請選擇"
                  @change="changeWorkCounty($event, index)"
                  v-model="item.WorkCountyGuid"
                >
                  <el-option
                    v-for="city in cityOptions"
                    :key="city.Guid"
                    :label="city.Name"
                    :value="city.Guid"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div class="col-md-3" :key="'WorkDistrict' + index">
            <div class="field">
              <div class="field-title">
                <span :style="{ color: fontColor }">
                  工作區域
                  <span class="en-text">Work location (District)</span>
                </span>
              </div>
              <div class="field-value">
                <el-select
                  class="w-100"
                  filterable
                  placeholder="請先選擇縣市"
                  v-model="item.WorkDistrictGuid"
                >
                  <el-option
                    v-for="district in item.districtOptions"
                    :key="district.Guid"
                    :label="district.Name"
                    :value="district.Guid"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <div
            v-if="workExperience.length > 1"
            class="col-md-6"
            :key="'button' + index"
          >
            <button type="button" class="del-btn" @click="del(index)">
              {{ $t("BUTTON.RESUME_DELETE") }}
            </button>
          </div>
        </template>
      </div>

      <div class="edit-btn-wrap">
        <!-- 新增 -->
        <button
          v-if="hasExperience"
          type="button"
          class="btn-sm add-btn"
          @click="add"
        >
          {{ $t("BUTTON.RESUME_ADD") }}
        </button>
        <!-- 儲存 -->
        <button
          type="button"
          class="put-btn"
          @click="handleSubmit(saveWorkExperience)"
        >
          {{ $t("BUTTON.RESUME_SAVE") }}
        </button>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: ["source", "nextTab", "matchId"],
  name: "AseIDLWorkExperience",

  data() {
    return {
      hasExperience: null,
      workExperience: [],

      // 行政區快取：CountyGuid -> Promise<districts[]>
      districtCache: {},

      backgroundColor: "#f1f1f1",
      fontColor: "#000",
    };
  },

  methods: {
    // 儲存 工作經歷
    saveWorkExperience() {
      let workExperience = this.workExperience.map((item) => {
        return {
          ...item,
          BasicSalary: item.BasicSalary
            ? Number(item.BasicSalary.replace(/,/g, ""))
            : null,
          FixedAllowance: item.FixedAllowance
            ? Number(item.FixedAllowance.replace(/,/g, ""))
            : null,
          VaryingBonus: item.VaryingBonus
            ? Number(item.VaryingBonus.replace(/,/g, ""))
            : null,
          YearlySalary: item.YearlySalary
            ? Number(item.YearlySalary.replace(/,/g, ""))
            : null,
        };
      });
      this.$api.idl
        .putWorkExperience(this.source, {
          Details: workExperience,
          UserId:
            this.source === "resume" ? this.$cookies.get("candidateId") : null,
          MatchId: this.source === "personnelInformation" ? this.matchId : null,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "工作經歷儲存成功",
              type: "success",
              duration: 2000,
            });
            if (this.source === "resume") {
              this.$store.dispatch("GetResumeCompleteness");
            }
            this.getWorkExperience();
            this.$emit("changeTab", this.nextTab);
          }
        });
    },

    // 取得 工作經歷
    getWorkExperience() {
      const candidate =
        this.source === "resume"
          ? this.$cookies.get("candidateId")
          : this.matchId;
      this.updateLoading(true);
      this.$api.idl
        .getWorkExperience(this.source, candidate)
        .then((response) => {
          if (response.status === 200) {
            if (response.data.WorkExperiences.length !== 0) {
              this.workExperience = response.data.WorkExperiences.map(
                (item) => {
                  return {
                    ...item,
                    districtOptions: [],
                  };
                }
              );
              this.hasExperience = true;
            } else {
              this.hasExperience = response.data.HasWorkExperiences;
            }
          }
          this.updateLoading(false);
        });
    },

    // 依 CountyGuid 取得行政區（快取 Promise，避免 deep watcher 重複呼叫）
    fetchDistricts(countyGuid) {
      if (!countyGuid) return Promise.resolve([]);
      if (!this.districtCache[countyGuid]) {
        const promise = this.$api.address
          .getDistrict({ CountyGuid: countyGuid })
          .then((res) =>
            res.data.map((item) => ({ Guid: item.Guid, Name: item.Name }))
          )
          .catch((err) => {
            this.$delete(this.districtCache, countyGuid);
            throw err;
          });
        this.$set(this.districtCache, countyGuid, promise);
      }
      return this.districtCache[countyGuid];
    },

    // 變更 工作地點
    changeWorkCounty(target, index) {
      this.workExperience[index].WorkCountyGuid = target;
      this.workExperience[index].WorkDistrictGuid = null;
      this.workExperience[index].districtOptions = [];
    },

    add() {
      this.workExperience.push({
        id: null,
        WorkDistrictGuid: null,
        districtOptions: [],
      });
    },

    del(index) {
      this.workExperience.splice(index, 1);
    },

    async getData() {
      await this.$store.dispatch("GetCity");
      await this.getWorkExperience();
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  watch: {
    workExperience: {
      handler: function (newVal) {
        newVal.map((item) => {
          // 取得 工作區域
          if (item.WorkCountyGuid && item.districtOptions.length === 0) {
            this.fetchDistricts(item.WorkCountyGuid).then((districts) => {
              item.districtOptions = districts;
            });
          }
          // 底薪
          if (item.BasicSalary) {
            item.BasicSalary = this.$common.currencyThousands(
              String(item.BasicSalary)
            );
          }
          // 固定津貼
          if (item.FixedAllowance) {
            item.FixedAllowance = this.$common.currencyThousands(
              String(item.FixedAllowance)
            );
          }
          // 變動獎金
          if (item.VaryingBonus) {
            item.VaryingBonus = this.$common.currencyThousands(
              String(item.VaryingBonus)
            );
          }
          // 年薪
          if (item.YearlySalary) {
            item.YearlySalary = this.$common.currencyThousands(
              String(item.YearlySalary)
            );
          }
          // 若仍在職，終止年月值為 null
          if (item.OnTheJob === true) {
            item.ExperienceTo = null;
          }
          // 計算年資
          if (item.ExperienceFrom) {
            let experienceTo = item.ExperienceTo
              ? item.ExperienceTo
              : this.dayjs().format("YYYY-MM");
            let months = this.dayjs(experienceTo).diff(
              item.ExperienceFrom,
              "month"
            );
            months += 1;
            let int = Math.floor(months / 12);
            let float = Math.floor(((months % 12) / 12) * 10) / 10;
            item.Seniority = float === 0 ? int : int + float;
          }
        });
      },
      deep: true,
    },

    hasExperience: function (newVal) {
      if (newVal) {
        if (this.workExperience.length === 0) {
          this.add();
        }
      } else {
        this.workExperience = [];
      }
    },
  },

  computed: {
    ...mapGetters(["cityOptions"]),
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.getData();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  },
};
</script>

<style lang="scss" scoped>
.field-title {
  .en-text {
    opacity: 0.6;
    font-size: 0.85em;
    margin-left: 5px;
  }
}

button {
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  font-size: 15px;
}

.del-btn {
  background: #ff3232;
  margin-top: 25px;
  color: #fff;
  margin-right: 10px;
}

.edit-btn-wrap {
  margin-top: 20px;
  button {
    background: #18c58b;
    color: #fff;
  }
  .add-btn {
    background: #fff;
    color: #000;
    margin-right: 5px;
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}

/deep/ .el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}
</style>
